import {
  faAtom,
  faDog,
  faMicroscope,
} from "@fortawesome/pro-solid-svg-icons";
import { useState } from "react";

import {
  AtomsSection,
  MoleculesSection,
  OrganismsSection,
} from "./DesignSystemTestPage/index";
import { DSTabs } from "./organisms";
import DarkModeToggle from "../account/DarkModeToggle";

type TabType = "atoms" | "molecules" | "organisms";

const DesignSystemTestPage = () => {
  const [activeTab, setActiveTab] = useState<TabType>("molecules");

  return (
    <div>
      <div className="min-h-screen bg-primary p-lg">
        <div className="max-w-7xl mx-auto">
          <div className="flex items-start justify-between mb-lg">
            <div>
              <h1 className="mb-sm">Design System Test Page</h1>
              <p>
                Only accessible in development and QA environments
              </p>
            </div>
            <DarkModeToggle />
          </div>

          {/* Tab Navigation using DSTabs */}
          <DSTabs
            value={activeTab}
            onChange={(value) => setActiveTab(value as TabType)}
            dataTestId="ds-test-main-tabs"
          >
            <DSTabs.List>
              <DSTabs.Tab icon={faAtom} value="atoms">
                Atoms
              </DSTabs.Tab>
              <DSTabs.Tab icon={faMicroscope} value="molecules">
                Molecules
              </DSTabs.Tab>
              <DSTabs.Tab icon={faDog} value="organisms">
                Organisms
              </DSTabs.Tab>
            </DSTabs.List>

            <DSTabs.Panel value="atoms">
              <AtomsSection />
            </DSTabs.Panel>
            <DSTabs.Panel value="molecules">
              <MoleculesSection />
            </DSTabs.Panel>
            <DSTabs.Panel value="organisms">
              <OrganismsSection />
            </DSTabs.Panel>
          </DSTabs>
        </div>
      </div>
    </div>
  );
};

export default DesignSystemTestPage;
